import { render, staticRenderFns } from "./SalesGroupDetail.vue?vue&type=template&id=22bc678e"
import script from "./SalesGroupDetail.vue?vue&type=script&lang=js"
export * from "./SalesGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./SalesGroupDetail.vue?vue&type=style&index=0&id=22bc678e&prod&lang=css"
import style1 from "./SalesGroupDetail.vue?vue&type=style&index=1&id=22bc678e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports